import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';

import useFetchCategory from '../../hooks/useFetchCategory';
import clientOnly from '../../hoc/clientOnly';

import './ProductListPager.module.css';

const numberOfProducts = 4;

const ProductListPager = ({
  className,
  categoryId,
  storeId,
  resultCallback,
  t
}) => {
  const [page, setPage] = useState(0);
  const { loading, result } = useFetchCategory(
    storeId || 'us_en',
    categoryId,
    page
  );

  if (result) {
    resultCallback(result);
  }

  const handlePrevious = () => {
    setPage(page - 1);
  };
  const handleNext = () => {
    setPage(page + 1);
  };

  return (
    <div className={className}>
      <button
        styleName="button previous"
        disabled={loading || page <= 0}
        onClick={handlePrevious}
        aria-label={t(`Show previous ${numberOfProducts} products`)}
      />
      <button
        styleName={classnames('button', { next: !loading, loading })}
        disabled={
          loading ||
          (result && numberOfProducts * (page + 1) >= result.totalCount)
        }
        onClick={handleNext}
        aria-label={t(`Show next ${numberOfProducts} products`)}
      />
    </div>
  );
};

export default compose(
  connect(state => {
    return {
      storeId: state.store.id
    };
  }),
  withTranslation(),
  clientOnly
)(ProductListPager);
